module.exports = __webpack_public_path__ + "images/stickers/taco-robot.c695266748c83f796b9a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-robot.png
// module id = aAl2
// module chunks = 0